import React, { useEffect, useState } from 'react';
import { Clock, Check, X, Download } from 'lucide-react';
import ApplicationsContent from '../admin/ApplicationsContent';

/* ─── Design tokens (kept identical to RecruiterDashboard for consistent UI) ─── */
export const APP = {
  bg:          '#f1f5f9',
  card:        '#ffffff',
  border:      '#e2e8f0',
  borderLight: '#f1f5f9',

  primary:     '#6366f1',
  primaryDark: '#4f46e5',
  primaryBg:   '#eef2ff',

  purple:      '#7c3aed',
  purpleBg:    '#ede9fe',

  green:       '#10b981',
  greenBg:     '#d1fae5',

  amber:       '#f59e0b',
  amberBg:     '#fef3c7',

  red:         '#ef4444',
  redBg:       '#fee2e2',

  sky:         '#0ea5e9',
  skyBg:       '#e0f2fe',

  pink:        '#ec4899',
  pinkBg:      '#fce7f3',

  text:        '#0f172a',
  textMd:      '#334155',
  textSm:      '#64748b',
  textXs:      '#012760',

  spinnerBorder: '#6366f1',
};

export const STATUS_COLORS = {
  pending:  APP.amber,
  accepted: APP.green,
  rejected: APP.red,
};

/* ─── Tiny reusable pieces (used inside ApplicationsContent / this tab) ───── */
export const StatusBadge = ({ status }) => {
  const key = status?.toLowerCase();
  const map = {
    pending:  { bg: APP.amberBg, color: '#92400e', Icon: Clock  },
    accepted: { bg: APP.greenBg, color: '#065f46', Icon: Check  },
    rejected: { bg: APP.redBg,   color: '#991b1b', Icon: X      },
  };
  const { bg, color, Icon } = map[key] || { bg: '#f1f5f9', color: APP.textSm, Icon: null };
  return (
    <span style={{ backgroundColor: bg, color, border: `1px solid ${bg}` }}
      className="inline-flex items-center gap-1 px-2 py-0.5 rounded-full text-xs font-medium">
      {Icon && <Icon size={10} />}
      {status?.charAt(0).toUpperCase() + status?.slice(1)}
    </span>
  );
};

export const IconPill = ({ icon: Icon, bg, color }) => (
  <div style={{ backgroundColor: bg }}
    className="w-10 h-10 rounded-full flex items-center justify-center flex-shrink-0">
    <Icon size={18} style={{ color }} />
  </div>
);

const tooltipStyle = {
  borderRadius: 10, border: 'none',
  boxShadow: '0 4px 20px rgba(0,0,0,0.10)', fontSize: 12,
  backgroundColor: '#fff', color: APP.textMd,
};

/* ─── DashbordApplicationTab ────────────────────────────────────────────────
   Renders the "Applications" section of the Recruiter Dashboard.
   Pass in dashboardData exactly as received from the dashboard API.
──────────────────────────────────────────────────────────────────────────── */
const DashbordApplicationTab = ({ dashboardData, selectedCandidate, onClearSelection }) => {
  const [search, setSearch] = useState('');

  useEffect(() => {
    if (selectedCandidate?.name) {
      setSearch(selectedCandidate.name);
      onClearSelection?.();
    }
  }, [selectedCandidate]);

  return (
    <ApplicationsContent dashboardData={dashboardData} />
  );
};

export default DashbordApplicationTab;